import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <div className='wrapFooter'>
        <div className="contentFooter col-sm-8">
         
            <p>
                
            Egurukulapps helps in efficiently managing day to day activities of your institute.
                  Create your own school and enjoy benefits of professional school management software!  
            </p>
            <div className="wrapFooterTabs">
                <div className="footerTab">ABOUT US</div>
                <div className="footerTab">TERMS&CONDITIONS</div>
                <div className="footerTab">PRIVACY POLICY</div>
                <div className="footerTab">CONTACT US</div>
            </div>
            {/* <div className="footerIcons">
                <span>Follow us on: </span>
                <i><TwitterIcon style={{backgroundColor:"white",color:"#003953",borderRadius:"50%",height:"25px",width:"25px",padding:"5px",marginLeft:"10px"}} /></i>
                <i><InstagramIcon style={{backgroundColor:"white",color:"#003953",borderRadius:"50%",height:"25px",width:"25px",padding:"5px",marginLeft:"10px"}} /></i>
                <i><LinkedInIcon style={{borderRadius:"50%",height:"32px",width:"42px"}} /></i>
            </div> */}
        </div>
        <div className="copyright">&copy; EgurukulApps. All rights reserved.</div>
    </div>
  )
}

export default Footer
